import { render, staticRenderFns } from "./KnowhowBlock.vue?vue&type=template&id=47141646"
import script from "./KnowhowBlock.vue?vue&type=script&lang=js"
export * from "./KnowhowBlock.vue?vue&type=script&lang=js"
import style0 from "./KnowhowBlock.vue?vue&type=style&index=0&id=47141646&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports